import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ITranslatedTableService } from 'app/admin/config/TranslatedTableConfig';

@Injectable({
  providedIn: 'root'
})
export class PartnerPricingToolFeatureService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/partnerpricingtoolfeatures`;

  constructor(private http: HttpClient) { }

  getByPriceLevelId(partnerPricingToolPriceLevelId: number, languageId: number): Observable<Boo.Objects.SEOPresence.PartnerPricingToolFeature[]> {
    const params = new HttpParams()
      .set('partnerPricingToolPriceLevelId', partnerPricingToolPriceLevelId)
      .set('languageId', languageId);

    return this.http.get<Boo.Objects.SEOPresence.PartnerPricingToolFeature[]>(`${this.baseUrl}/GetByPriceLevelId`, { params: params });
  }
}
